import ChangePayoutLineStatusMock from "./ChangePayoutLineStatus.mock"

export default [ChangePayoutLineStatusMock]
